import { State } from '@frontend-site/shared/utils';
import { MainHeaderMenu } from './main-header-menu';
import { MegaMenuColumn } from './mega-menu-column';
import { Data, Params } from '@angular/router';
import { DefaultMainHeaderMenu } from './default-main-header-menu';
import { MenuStates } from './menu-states.enum';

export interface RouteData {
    data?: Data;
    params?: Params;
}

export interface MenuState extends State {
    mainHeaderMenu: MainHeaderMenu;
    megaMenuColumns: MegaMenuColumn[];
}

export function createInitialState(): MenuState {
    return {
        mainHeaderMenu: new DefaultMainHeaderMenu(MenuStates.NONE, { title: '', items: [] }),
        megaMenuColumns: []
    };
}
